/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TotpResetRouteImport } from './routes/totp-reset'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as PrivateRouteImport } from './routes/_private'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicSignUpRouteImport } from './routes/_public/sign-up'
import { Route as PublicSignInRouteImport } from './routes/_public/sign-in'
import { Route as PublicPasswordResetRouteImport } from './routes/_public/password-reset'
import { Route as PrivateWithdrawRouteImport } from './routes/_private/withdraw'
import { Route as PrivateWalletRouteImport } from './routes/_private/wallet'
import { Route as PrivateVerifyRouteImport } from './routes/_private/verify'
import { Route as PrivateTwoFaVerifyRouteImport } from './routes/_private/two-fa-verify'
import { Route as PrivateTransactionsRouteImport } from './routes/_private/transactions'
import { Route as PrivateTopUpRouteImport } from './routes/_private/top-up'
import { Route as PrivateSellRouteImport } from './routes/_private/sell'
import { Route as PrivateSecurityRouteImport } from './routes/_private/security'
import { Route as PrivateQuestionnaireAgreementRouteImport } from './routes/_private/questionnaire-agreement'
import { Route as PrivatePublicOfferRouteImport } from './routes/_private/public-offer'
import { Route as PrivateProfileDetailsRouteImport } from './routes/_private/profile-details'
import { Route as PrivateProfileRouteImport } from './routes/_private/profile'
import { Route as PrivatePoliciesAgreementRouteImport } from './routes/_private/policies-agreement'
import { Route as PrivatePhoneVerifyRouteImport } from './routes/_private/phone-verify'
import { Route as PrivateOtpDeliveryRouteImport } from './routes/_private/otp-delivery'
import { Route as PrivateNotificationsRouteImport } from './routes/_private/notifications'
import { Route as PrivateKycVerifyRouteImport } from './routes/_private/kyc-verify'
import { Route as PrivateKybVerifyRouteImport } from './routes/_private/kyb-verify'
import { Route as PrivateHelpRouteImport } from './routes/_private/help'
import { Route as PrivateExchangeRouteImport } from './routes/_private/exchange'
import { Route as PrivateDocumentsRouteImport } from './routes/_private/documents'
import { Route as PrivateConnectTwoFaRouteImport } from './routes/_private/connect-two-fa'
import { Route as PrivateChangePasswordRouteImport } from './routes/_private/change-password'
import { Route as PrivateBuyRouteImport } from './routes/_private/buy'
import { Route as PrivateSessionsIndexRouteImport } from './routes/_private/sessions/index'
import { Route as PrivateRequisitesIndexRouteImport } from './routes/_private/requisites/index'
import { Route as PrivateOrdersIndexRouteImport } from './routes/_private/orders/index'
import { Route as PrivateSessionsIdRouteImport } from './routes/_private/sessions/$id'
import { Route as PrivateRequisitesIdRouteImport } from './routes/_private/requisites/$id'
import { Route as PrivateOrdersDocumentsRouteImport } from './routes/_private/orders/documents'
import { Route as PrivateOrdersIdRouteImport } from './routes/_private/orders/$id'

const TotpResetRoute = TotpResetRouteImport.update({
  id: '/totp-reset',
  path: '/totp-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivateRoute = PrivateRouteImport.update({
  id: '/_private',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicSignUpRoute = PublicSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => PublicRoute,
} as any)
const PublicSignInRoute = PublicSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => PublicRoute,
} as any)
const PublicPasswordResetRoute = PublicPasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => PublicRoute,
} as any)
const PrivateWithdrawRoute = PrivateWithdrawRouteImport.update({
  id: '/withdraw',
  path: '/withdraw',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateWalletRoute = PrivateWalletRouteImport.update({
  id: '/wallet',
  path: '/wallet',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateVerifyRoute = PrivateVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateTwoFaVerifyRoute = PrivateTwoFaVerifyRouteImport.update({
  id: '/two-fa-verify',
  path: '/two-fa-verify',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateTransactionsRoute = PrivateTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateTopUpRoute = PrivateTopUpRouteImport.update({
  id: '/top-up',
  path: '/top-up',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateSellRoute = PrivateSellRouteImport.update({
  id: '/sell',
  path: '/sell',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateSecurityRoute = PrivateSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateQuestionnaireAgreementRoute =
  PrivateQuestionnaireAgreementRouteImport.update({
    id: '/questionnaire-agreement',
    path: '/questionnaire-agreement',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivatePublicOfferRoute = PrivatePublicOfferRouteImport.update({
  id: '/public-offer',
  path: '/public-offer',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateProfileDetailsRoute = PrivateProfileDetailsRouteImport.update({
  id: '/profile-details',
  path: '/profile-details',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateProfileRoute = PrivateProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivatePoliciesAgreementRoute =
  PrivatePoliciesAgreementRouteImport.update({
    id: '/policies-agreement',
    path: '/policies-agreement',
    getParentRoute: () => PrivateRoute,
  } as any)
const PrivatePhoneVerifyRoute = PrivatePhoneVerifyRouteImport.update({
  id: '/phone-verify',
  path: '/phone-verify',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateOtpDeliveryRoute = PrivateOtpDeliveryRouteImport.update({
  id: '/otp-delivery',
  path: '/otp-delivery',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateNotificationsRoute = PrivateNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateKycVerifyRoute = PrivateKycVerifyRouteImport.update({
  id: '/kyc-verify',
  path: '/kyc-verify',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateKybVerifyRoute = PrivateKybVerifyRouteImport.update({
  id: '/kyb-verify',
  path: '/kyb-verify',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateHelpRoute = PrivateHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateExchangeRoute = PrivateExchangeRouteImport.update({
  id: '/exchange',
  path: '/exchange',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateDocumentsRoute = PrivateDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateConnectTwoFaRoute = PrivateConnectTwoFaRouteImport.update({
  id: '/connect-two-fa',
  path: '/connect-two-fa',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateChangePasswordRoute = PrivateChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateBuyRoute = PrivateBuyRouteImport.update({
  id: '/buy',
  path: '/buy',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateSessionsIndexRoute = PrivateSessionsIndexRouteImport.update({
  id: '/sessions/',
  path: '/sessions/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateRequisitesIndexRoute = PrivateRequisitesIndexRouteImport.update({
  id: '/requisites/',
  path: '/requisites/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateOrdersIndexRoute = PrivateOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateSessionsIdRoute = PrivateSessionsIdRouteImport.update({
  id: '/sessions/$id',
  path: '/sessions/$id',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateRequisitesIdRoute = PrivateRequisitesIdRouteImport.update({
  id: '/requisites/$id',
  path: '/requisites/$id',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateOrdersDocumentsRoute = PrivateOrdersDocumentsRouteImport.update({
  id: '/orders/documents',
  path: '/orders/documents',
  getParentRoute: () => PrivateRoute,
} as any)
const PrivateOrdersIdRoute = PrivateOrdersIdRouteImport.update({
  id: '/orders/$id',
  path: '/orders/$id',
  getParentRoute: () => PrivateRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/totp-reset': typeof TotpResetRoute
  '/buy': typeof PrivateBuyRoute
  '/change-password': typeof PrivateChangePasswordRoute
  '/connect-two-fa': typeof PrivateConnectTwoFaRoute
  '/documents': typeof PrivateDocumentsRoute
  '/exchange': typeof PrivateExchangeRoute
  '/help': typeof PrivateHelpRoute
  '/kyb-verify': typeof PrivateKybVerifyRoute
  '/kyc-verify': typeof PrivateKycVerifyRoute
  '/notifications': typeof PrivateNotificationsRoute
  '/otp-delivery': typeof PrivateOtpDeliveryRoute
  '/phone-verify': typeof PrivatePhoneVerifyRoute
  '/policies-agreement': typeof PrivatePoliciesAgreementRoute
  '/profile': typeof PrivateProfileRoute
  '/profile-details': typeof PrivateProfileDetailsRoute
  '/public-offer': typeof PrivatePublicOfferRoute
  '/questionnaire-agreement': typeof PrivateQuestionnaireAgreementRoute
  '/security': typeof PrivateSecurityRoute
  '/sell': typeof PrivateSellRoute
  '/top-up': typeof PrivateTopUpRoute
  '/transactions': typeof PrivateTransactionsRoute
  '/two-fa-verify': typeof PrivateTwoFaVerifyRoute
  '/verify': typeof PrivateVerifyRoute
  '/wallet': typeof PrivateWalletRoute
  '/withdraw': typeof PrivateWithdrawRoute
  '/password-reset': typeof PublicPasswordResetRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-up': typeof PublicSignUpRoute
  '/orders/$id': typeof PrivateOrdersIdRoute
  '/orders/documents': typeof PrivateOrdersDocumentsRoute
  '/requisites/$id': typeof PrivateRequisitesIdRoute
  '/sessions/$id': typeof PrivateSessionsIdRoute
  '/orders': typeof PrivateOrdersIndexRoute
  '/requisites': typeof PrivateRequisitesIndexRoute
  '/sessions': typeof PrivateSessionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/totp-reset': typeof TotpResetRoute
  '/buy': typeof PrivateBuyRoute
  '/change-password': typeof PrivateChangePasswordRoute
  '/connect-two-fa': typeof PrivateConnectTwoFaRoute
  '/documents': typeof PrivateDocumentsRoute
  '/exchange': typeof PrivateExchangeRoute
  '/help': typeof PrivateHelpRoute
  '/kyb-verify': typeof PrivateKybVerifyRoute
  '/kyc-verify': typeof PrivateKycVerifyRoute
  '/notifications': typeof PrivateNotificationsRoute
  '/otp-delivery': typeof PrivateOtpDeliveryRoute
  '/phone-verify': typeof PrivatePhoneVerifyRoute
  '/policies-agreement': typeof PrivatePoliciesAgreementRoute
  '/profile': typeof PrivateProfileRoute
  '/profile-details': typeof PrivateProfileDetailsRoute
  '/public-offer': typeof PrivatePublicOfferRoute
  '/questionnaire-agreement': typeof PrivateQuestionnaireAgreementRoute
  '/security': typeof PrivateSecurityRoute
  '/sell': typeof PrivateSellRoute
  '/top-up': typeof PrivateTopUpRoute
  '/transactions': typeof PrivateTransactionsRoute
  '/two-fa-verify': typeof PrivateTwoFaVerifyRoute
  '/verify': typeof PrivateVerifyRoute
  '/wallet': typeof PrivateWalletRoute
  '/withdraw': typeof PrivateWithdrawRoute
  '/password-reset': typeof PublicPasswordResetRoute
  '/sign-in': typeof PublicSignInRoute
  '/sign-up': typeof PublicSignUpRoute
  '/orders/$id': typeof PrivateOrdersIdRoute
  '/orders/documents': typeof PrivateOrdersDocumentsRoute
  '/requisites/$id': typeof PrivateRequisitesIdRoute
  '/sessions/$id': typeof PrivateSessionsIdRoute
  '/orders': typeof PrivateOrdersIndexRoute
  '/requisites': typeof PrivateRequisitesIndexRoute
  '/sessions': typeof PrivateSessionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_private': typeof PrivateRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/totp-reset': typeof TotpResetRoute
  '/_private/buy': typeof PrivateBuyRoute
  '/_private/change-password': typeof PrivateChangePasswordRoute
  '/_private/connect-two-fa': typeof PrivateConnectTwoFaRoute
  '/_private/documents': typeof PrivateDocumentsRoute
  '/_private/exchange': typeof PrivateExchangeRoute
  '/_private/help': typeof PrivateHelpRoute
  '/_private/kyb-verify': typeof PrivateKybVerifyRoute
  '/_private/kyc-verify': typeof PrivateKycVerifyRoute
  '/_private/notifications': typeof PrivateNotificationsRoute
  '/_private/otp-delivery': typeof PrivateOtpDeliveryRoute
  '/_private/phone-verify': typeof PrivatePhoneVerifyRoute
  '/_private/policies-agreement': typeof PrivatePoliciesAgreementRoute
  '/_private/profile': typeof PrivateProfileRoute
  '/_private/profile-details': typeof PrivateProfileDetailsRoute
  '/_private/public-offer': typeof PrivatePublicOfferRoute
  '/_private/questionnaire-agreement': typeof PrivateQuestionnaireAgreementRoute
  '/_private/security': typeof PrivateSecurityRoute
  '/_private/sell': typeof PrivateSellRoute
  '/_private/top-up': typeof PrivateTopUpRoute
  '/_private/transactions': typeof PrivateTransactionsRoute
  '/_private/two-fa-verify': typeof PrivateTwoFaVerifyRoute
  '/_private/verify': typeof PrivateVerifyRoute
  '/_private/wallet': typeof PrivateWalletRoute
  '/_private/withdraw': typeof PrivateWithdrawRoute
  '/_public/password-reset': typeof PublicPasswordResetRoute
  '/_public/sign-in': typeof PublicSignInRoute
  '/_public/sign-up': typeof PublicSignUpRoute
  '/_private/orders/$id': typeof PrivateOrdersIdRoute
  '/_private/orders/documents': typeof PrivateOrdersDocumentsRoute
  '/_private/requisites/$id': typeof PrivateRequisitesIdRoute
  '/_private/sessions/$id': typeof PrivateSessionsIdRoute
  '/_private/orders/': typeof PrivateOrdersIndexRoute
  '/_private/requisites/': typeof PrivateRequisitesIndexRoute
  '/_private/sessions/': typeof PrivateSessionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/totp-reset'
    | '/buy'
    | '/change-password'
    | '/connect-two-fa'
    | '/documents'
    | '/exchange'
    | '/help'
    | '/kyb-verify'
    | '/kyc-verify'
    | '/notifications'
    | '/otp-delivery'
    | '/phone-verify'
    | '/policies-agreement'
    | '/profile'
    | '/profile-details'
    | '/public-offer'
    | '/questionnaire-agreement'
    | '/security'
    | '/sell'
    | '/top-up'
    | '/transactions'
    | '/two-fa-verify'
    | '/verify'
    | '/wallet'
    | '/withdraw'
    | '/password-reset'
    | '/sign-in'
    | '/sign-up'
    | '/orders/$id'
    | '/orders/documents'
    | '/requisites/$id'
    | '/sessions/$id'
    | '/orders'
    | '/requisites'
    | '/sessions'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/totp-reset'
    | '/buy'
    | '/change-password'
    | '/connect-two-fa'
    | '/documents'
    | '/exchange'
    | '/help'
    | '/kyb-verify'
    | '/kyc-verify'
    | '/notifications'
    | '/otp-delivery'
    | '/phone-verify'
    | '/policies-agreement'
    | '/profile'
    | '/profile-details'
    | '/public-offer'
    | '/questionnaire-agreement'
    | '/security'
    | '/sell'
    | '/top-up'
    | '/transactions'
    | '/two-fa-verify'
    | '/verify'
    | '/wallet'
    | '/withdraw'
    | '/password-reset'
    | '/sign-in'
    | '/sign-up'
    | '/orders/$id'
    | '/orders/documents'
    | '/requisites/$id'
    | '/sessions/$id'
    | '/orders'
    | '/requisites'
    | '/sessions'
  id:
    | '__root__'
    | '/'
    | '/_private'
    | '/_public'
    | '/totp-reset'
    | '/_private/buy'
    | '/_private/change-password'
    | '/_private/connect-two-fa'
    | '/_private/documents'
    | '/_private/exchange'
    | '/_private/help'
    | '/_private/kyb-verify'
    | '/_private/kyc-verify'
    | '/_private/notifications'
    | '/_private/otp-delivery'
    | '/_private/phone-verify'
    | '/_private/policies-agreement'
    | '/_private/profile'
    | '/_private/profile-details'
    | '/_private/public-offer'
    | '/_private/questionnaire-agreement'
    | '/_private/security'
    | '/_private/sell'
    | '/_private/top-up'
    | '/_private/transactions'
    | '/_private/two-fa-verify'
    | '/_private/verify'
    | '/_private/wallet'
    | '/_private/withdraw'
    | '/_public/password-reset'
    | '/_public/sign-in'
    | '/_public/sign-up'
    | '/_private/orders/$id'
    | '/_private/orders/documents'
    | '/_private/requisites/$id'
    | '/_private/sessions/$id'
    | '/_private/orders/'
    | '/_private/requisites/'
    | '/_private/sessions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PrivateRoute: typeof PrivateRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
  TotpResetRoute: typeof TotpResetRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/totp-reset': {
      id: '/totp-reset'
      path: '/totp-reset'
      fullPath: '/totp-reset'
      preLoaderRoute: typeof TotpResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_private': {
      id: '/_private'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PrivateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/sign-up': {
      id: '/_public/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof PublicSignUpRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/sign-in': {
      id: '/_public/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof PublicSignInRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_public/password-reset': {
      id: '/_public/password-reset'
      path: '/password-reset'
      fullPath: '/password-reset'
      preLoaderRoute: typeof PublicPasswordResetRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_private/withdraw': {
      id: '/_private/withdraw'
      path: '/withdraw'
      fullPath: '/withdraw'
      preLoaderRoute: typeof PrivateWithdrawRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/wallet': {
      id: '/_private/wallet'
      path: '/wallet'
      fullPath: '/wallet'
      preLoaderRoute: typeof PrivateWalletRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/verify': {
      id: '/_private/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof PrivateVerifyRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/two-fa-verify': {
      id: '/_private/two-fa-verify'
      path: '/two-fa-verify'
      fullPath: '/two-fa-verify'
      preLoaderRoute: typeof PrivateTwoFaVerifyRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/transactions': {
      id: '/_private/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof PrivateTransactionsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/top-up': {
      id: '/_private/top-up'
      path: '/top-up'
      fullPath: '/top-up'
      preLoaderRoute: typeof PrivateTopUpRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/sell': {
      id: '/_private/sell'
      path: '/sell'
      fullPath: '/sell'
      preLoaderRoute: typeof PrivateSellRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/security': {
      id: '/_private/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof PrivateSecurityRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/questionnaire-agreement': {
      id: '/_private/questionnaire-agreement'
      path: '/questionnaire-agreement'
      fullPath: '/questionnaire-agreement'
      preLoaderRoute: typeof PrivateQuestionnaireAgreementRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/public-offer': {
      id: '/_private/public-offer'
      path: '/public-offer'
      fullPath: '/public-offer'
      preLoaderRoute: typeof PrivatePublicOfferRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/profile-details': {
      id: '/_private/profile-details'
      path: '/profile-details'
      fullPath: '/profile-details'
      preLoaderRoute: typeof PrivateProfileDetailsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/profile': {
      id: '/_private/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof PrivateProfileRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/policies-agreement': {
      id: '/_private/policies-agreement'
      path: '/policies-agreement'
      fullPath: '/policies-agreement'
      preLoaderRoute: typeof PrivatePoliciesAgreementRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/phone-verify': {
      id: '/_private/phone-verify'
      path: '/phone-verify'
      fullPath: '/phone-verify'
      preLoaderRoute: typeof PrivatePhoneVerifyRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/otp-delivery': {
      id: '/_private/otp-delivery'
      path: '/otp-delivery'
      fullPath: '/otp-delivery'
      preLoaderRoute: typeof PrivateOtpDeliveryRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/notifications': {
      id: '/_private/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof PrivateNotificationsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/kyc-verify': {
      id: '/_private/kyc-verify'
      path: '/kyc-verify'
      fullPath: '/kyc-verify'
      preLoaderRoute: typeof PrivateKycVerifyRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/kyb-verify': {
      id: '/_private/kyb-verify'
      path: '/kyb-verify'
      fullPath: '/kyb-verify'
      preLoaderRoute: typeof PrivateKybVerifyRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/help': {
      id: '/_private/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof PrivateHelpRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/exchange': {
      id: '/_private/exchange'
      path: '/exchange'
      fullPath: '/exchange'
      preLoaderRoute: typeof PrivateExchangeRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/documents': {
      id: '/_private/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof PrivateDocumentsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/connect-two-fa': {
      id: '/_private/connect-two-fa'
      path: '/connect-two-fa'
      fullPath: '/connect-two-fa'
      preLoaderRoute: typeof PrivateConnectTwoFaRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/change-password': {
      id: '/_private/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof PrivateChangePasswordRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/buy': {
      id: '/_private/buy'
      path: '/buy'
      fullPath: '/buy'
      preLoaderRoute: typeof PrivateBuyRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/sessions/': {
      id: '/_private/sessions/'
      path: '/sessions'
      fullPath: '/sessions'
      preLoaderRoute: typeof PrivateSessionsIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/requisites/': {
      id: '/_private/requisites/'
      path: '/requisites'
      fullPath: '/requisites'
      preLoaderRoute: typeof PrivateRequisitesIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/orders/': {
      id: '/_private/orders/'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof PrivateOrdersIndexRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/sessions/$id': {
      id: '/_private/sessions/$id'
      path: '/sessions/$id'
      fullPath: '/sessions/$id'
      preLoaderRoute: typeof PrivateSessionsIdRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/requisites/$id': {
      id: '/_private/requisites/$id'
      path: '/requisites/$id'
      fullPath: '/requisites/$id'
      preLoaderRoute: typeof PrivateRequisitesIdRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/orders/documents': {
      id: '/_private/orders/documents'
      path: '/orders/documents'
      fullPath: '/orders/documents'
      preLoaderRoute: typeof PrivateOrdersDocumentsRouteImport
      parentRoute: typeof PrivateRoute
    }
    '/_private/orders/$id': {
      id: '/_private/orders/$id'
      path: '/orders/$id'
      fullPath: '/orders/$id'
      preLoaderRoute: typeof PrivateOrdersIdRouteImport
      parentRoute: typeof PrivateRoute
    }
  }
}

interface PrivateRouteChildren {
  PrivateBuyRoute: typeof PrivateBuyRoute
  PrivateChangePasswordRoute: typeof PrivateChangePasswordRoute
  PrivateConnectTwoFaRoute: typeof PrivateConnectTwoFaRoute
  PrivateDocumentsRoute: typeof PrivateDocumentsRoute
  PrivateExchangeRoute: typeof PrivateExchangeRoute
  PrivateHelpRoute: typeof PrivateHelpRoute
  PrivateKybVerifyRoute: typeof PrivateKybVerifyRoute
  PrivateKycVerifyRoute: typeof PrivateKycVerifyRoute
  PrivateNotificationsRoute: typeof PrivateNotificationsRoute
  PrivateOtpDeliveryRoute: typeof PrivateOtpDeliveryRoute
  PrivatePhoneVerifyRoute: typeof PrivatePhoneVerifyRoute
  PrivatePoliciesAgreementRoute: typeof PrivatePoliciesAgreementRoute
  PrivateProfileRoute: typeof PrivateProfileRoute
  PrivateProfileDetailsRoute: typeof PrivateProfileDetailsRoute
  PrivatePublicOfferRoute: typeof PrivatePublicOfferRoute
  PrivateQuestionnaireAgreementRoute: typeof PrivateQuestionnaireAgreementRoute
  PrivateSecurityRoute: typeof PrivateSecurityRoute
  PrivateSellRoute: typeof PrivateSellRoute
  PrivateTopUpRoute: typeof PrivateTopUpRoute
  PrivateTransactionsRoute: typeof PrivateTransactionsRoute
  PrivateTwoFaVerifyRoute: typeof PrivateTwoFaVerifyRoute
  PrivateVerifyRoute: typeof PrivateVerifyRoute
  PrivateWalletRoute: typeof PrivateWalletRoute
  PrivateWithdrawRoute: typeof PrivateWithdrawRoute
  PrivateOrdersIdRoute: typeof PrivateOrdersIdRoute
  PrivateOrdersDocumentsRoute: typeof PrivateOrdersDocumentsRoute
  PrivateRequisitesIdRoute: typeof PrivateRequisitesIdRoute
  PrivateSessionsIdRoute: typeof PrivateSessionsIdRoute
  PrivateOrdersIndexRoute: typeof PrivateOrdersIndexRoute
  PrivateRequisitesIndexRoute: typeof PrivateRequisitesIndexRoute
  PrivateSessionsIndexRoute: typeof PrivateSessionsIndexRoute
}

const PrivateRouteChildren: PrivateRouteChildren = {
  PrivateBuyRoute: PrivateBuyRoute,
  PrivateChangePasswordRoute: PrivateChangePasswordRoute,
  PrivateConnectTwoFaRoute: PrivateConnectTwoFaRoute,
  PrivateDocumentsRoute: PrivateDocumentsRoute,
  PrivateExchangeRoute: PrivateExchangeRoute,
  PrivateHelpRoute: PrivateHelpRoute,
  PrivateKybVerifyRoute: PrivateKybVerifyRoute,
  PrivateKycVerifyRoute: PrivateKycVerifyRoute,
  PrivateNotificationsRoute: PrivateNotificationsRoute,
  PrivateOtpDeliveryRoute: PrivateOtpDeliveryRoute,
  PrivatePhoneVerifyRoute: PrivatePhoneVerifyRoute,
  PrivatePoliciesAgreementRoute: PrivatePoliciesAgreementRoute,
  PrivateProfileRoute: PrivateProfileRoute,
  PrivateProfileDetailsRoute: PrivateProfileDetailsRoute,
  PrivatePublicOfferRoute: PrivatePublicOfferRoute,
  PrivateQuestionnaireAgreementRoute: PrivateQuestionnaireAgreementRoute,
  PrivateSecurityRoute: PrivateSecurityRoute,
  PrivateSellRoute: PrivateSellRoute,
  PrivateTopUpRoute: PrivateTopUpRoute,
  PrivateTransactionsRoute: PrivateTransactionsRoute,
  PrivateTwoFaVerifyRoute: PrivateTwoFaVerifyRoute,
  PrivateVerifyRoute: PrivateVerifyRoute,
  PrivateWalletRoute: PrivateWalletRoute,
  PrivateWithdrawRoute: PrivateWithdrawRoute,
  PrivateOrdersIdRoute: PrivateOrdersIdRoute,
  PrivateOrdersDocumentsRoute: PrivateOrdersDocumentsRoute,
  PrivateRequisitesIdRoute: PrivateRequisitesIdRoute,
  PrivateSessionsIdRoute: PrivateSessionsIdRoute,
  PrivateOrdersIndexRoute: PrivateOrdersIndexRoute,
  PrivateRequisitesIndexRoute: PrivateRequisitesIndexRoute,
  PrivateSessionsIndexRoute: PrivateSessionsIndexRoute,
}

const PrivateRouteWithChildren =
  PrivateRoute._addFileChildren(PrivateRouteChildren)

interface PublicRouteChildren {
  PublicPasswordResetRoute: typeof PublicPasswordResetRoute
  PublicSignInRoute: typeof PublicSignInRoute
  PublicSignUpRoute: typeof PublicSignUpRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicPasswordResetRoute: PublicPasswordResetRoute,
  PublicSignInRoute: PublicSignInRoute,
  PublicSignUpRoute: PublicSignUpRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PrivateRoute: PrivateRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  TotpResetRoute: TotpResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
